import { Controller, FieldValues } from 'react-hook-form'
import classNames from 'classnames'

import { FormElementProps } from './types'
import { FormError } from '.'

const Textarea = <T extends FieldValues>({
  className,
  label,
  name,
  required,
  control,
  emptyValue,
  isEditing,
  onFieldChange,
  ...rest
}: FormElementProps<HTMLTextAreaElement, T>) => {
  if (!name) return null

  return (
    <label className={className}>
      {!!label && (
        <span className={classNames('name', { required: !!required })}>
          {label} {!!required && <sup>*</sup>}
        </span>
      )}
      <Controller
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            {emptyValue && [undefined, null, ''].includes(value) ? (
              <div className="empty-value">{emptyValue}</div>
            ) : (
              <textarea
                name={name}
                required={required}
                value={
                  ['string', 'number'].includes(typeof value) ? `${value}` : ''
                }
                onChange={e => {
                  onChange(e)
                  onFieldChange?.(e.target.value)
                }}
                {...rest}
              />
            )}
            {isEditing && <FormError error={error?.message} />}
          </>
        )}
        name={name}
      />
    </label>
  )
}

export default Textarea
